import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import { AuthReducer } from './AuthReducer';
import { ManagerReducer } from './ManagerReducer';
import { SurveyReducer } from './SurveyReducer';
import { SolutionsReducer } from './SolutionsReducer';
import { ResourcesReducer } from './Resources';
import { OnboardingReducer } from './OnboardingReducer';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: AuthReducer,
    manager: ManagerReducer,
    survey: SurveyReducer,
    solutions: SolutionsReducer,
    resources: ResourcesReducer,
    onboarding: OnboardingReducer,
  });

export default createRootReducer;
